import * as Yup from "yup";

export const countryDetailsSchema = Yup.object().shape({
  countryId: Yup.string().required("Country is required."),
  eligibleRetireCountryIds: Yup.array()
    .required()
    .of(Yup.string().required("Countries for investment are required."))
    .min(1, "At least one country must be selected."),
  images: Yup.array().min(1, "Image is required").required("Image is required"),
});
